import { CaseReviewCustomFieldModel } from '../caseReviewCustomField/caseReviewCustomFieldModel';
import { CaseReviewModel } from './caseReviewModel';

export class AddCaseReviewModel extends CaseReviewModel {
    public caseTypeIds: number[];
    public caseReviewCustomFields: CaseReviewCustomFieldModel[];
}
